import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// TODO: Add once design for autocomplete is finalized
import { MatOptionModule } from '@angular/material/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { StudentSearchModule } from '../student-search/student-search.module';
import { StudentNavigatorComponent } from './student-navigator.component';

@NgModule({
  imports: [
    MatIconModule,
    // TODO: Add once design for autocomplete is finalized
    MatFormFieldModule,
    MatAutocompleteModule,
    MatOptionModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    StudentSearchModule,
  ],
  declarations: [StudentNavigatorComponent],
  exports: [StudentNavigatorComponent],
})
export class StudentNavigatorModule {}
